import { Autocomplete, Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCompanySuppliersAction } from '../../BCMOrder/Action';
import { SupplierModuleTypeEnum } from '../../../utils/settings';
import { toast } from 'react-toastify';

const IndustryAndCompanyPicker = () => {
  const dispatch = useDispatch();

  const [supplierData, setSupplierData] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState('');
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState('');
  const getSuppliers = async () => {
    const { error, data, message } = await getCompanySuppliersAction(
      SupplierModuleTypeEnum.reports_enabled,
    );
    if (!error) {
      setSupplierData(data);
      setSelectedIndustry(data[0].sub_industry_id);
      setCompanyList(data[0].suppliers_list);
      setSelectedCompany(data[0].suppliers_list[0].id);

      dispatch({
        type: 'SET_COMPANY_DETAILS_REPORT_REDUCER',
        data: data[0].suppliers_list[0],
      });
    } else {
      toast.error(message);
    }
  };

  const handleIndustryChange = (event, value) => {
    if (value) {
      const selectedIndustry = supplierData.find(
        (item) => item.sub_industry_id === value.sub_industry_id,
      );

      if (selectedIndustry) {
        setCompanyList(selectedIndustry.suppliers_list);
        setSelectedCompany('');
        setSelectedIndustry(value.sub_industry_id);
      }
    }
  };
  const handleCompanyChange = (event, value) => {
    const selectedCompany = companyList.find((item) => item.id === value?.id);

    if (selectedCompany) {
      dispatch({
        type: 'SET_COMPANY_DETAILS_REPORT_REDUCER',
        data: selectedCompany,
      });
      setSelectedCompany(selectedCompany.id);
    }
  };

  useEffect(() => {
    getSuppliers();
  }, []);
  return (
      <Grid
        container
        spacing={2}
        sx={{ mb: 2 }}
      >
        <Grid
          item
          xs={6}
          md={4}
        >
          <Autocomplete
            fullWidth
            disablePortal
            options={supplierData}
            getOptionLabel={(option) => option.sub_industry_name}
            value={
              supplierData.find(
                (item) => item.sub_industry_id === selectedIndustry,
              ) || null
            }
            onChange={handleIndustryChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Select Industry'
                variant='outlined'
              />
            )}
            sx={{ width: {xs:'100%'}}}
          />
        </Grid>
        <Grid
          item
          xs={6}
          md={4}
        >
          <Autocomplete
            disablePortal
            options={companyList}
            getOptionLabel={(option) => option.name}
            value={companyList.find((item) => item.id === selectedCompany) || null}
            onChange={handleCompanyChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Select Company'
                variant='outlined'
              />
            )}
            // sx={{ width: '40%' }}
          />
        </Grid>
      </Grid>
  );
};

export default IndustryAndCompanyPicker;
